import { Moon, Sun } from 'lucide-react'
import { forwardRef } from 'react'
import { useTranslation } from 'react-i18next'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Button } from '../../shared/button/button'

export type HeaderThemeSwitchProps = {
  isDarkTheme: boolean
  onToggleTheme: () => void
}

export const HeaderThemeSwitch = forwardRef(function HeaderThemeSwitch(
  { isDarkTheme, onToggleTheme, ...props },
  ref,
) {
  const { t } = useTranslation()

  return (
    <Button
      size="sm"
      variant="outline"
      aria-label={isDarkTheme ? t('header.light-mode') : t('header.dark-mode')}
      iconStart={
        isDarkTheme ? <Sun className="h-4 w-4" /> : <Moon className="h-4 w-4" />
      }
      onClick={onToggleTheme}
      {...props}
      ref={ref}
    >
      <span className="hidden md:inline">
        {isDarkTheme ? t('header.light-mode') : t('header.dark-mode')}
      </span>
    </Button>
  )
}) as Polymorphic<'button', HeaderThemeSwitchProps>
